import { useLocation } from 'react-router-dom';

export function useCurrentDraftGroupId() {
    const { pathname } = useLocation();
    const groupId = pathname.split('/').pop() ?? '';

    return groupId;
}
